// 绘本相关API
import request from '@/utils/request'

// 微信网页授权登录
export function wechatOauthLogin(data) {
  return request({
    url: '/api/wechat/oauth-login',
    method: 'post',
    data
  })
}

// 获取微信 JSSDK 配置
export function getWechatJsSdkConfig(url) {
  return request({
    url: '/api/wechat/js-sdk-config',
    method: 'get',
    params: { url }
  })
}

// 获取绘本列表
export function getBooks() {
  return request({
    url: '/api/books',
    method: 'get'
  })
}

// 获取已解锁书本
export function getUnlockedBooks() {
  return request({
    url: '/api/serial-codes/unlocked-books',
    method: 'get'
  })
}

// 检查书本是否已绑定序列号
export function checkBookAccess(bookId) {
  return request({
    url: `/api/serial-codes/check/${bookId}`,
    method: 'get'
  })
}

// 绑定序列号
export function redeemSerial(data) {
  return request({
    url: '/api/serial-codes/redeem',
    method: 'post',
    data
  })
}

// 获取绘本跟读流程
export function getStoryPractice(bookId) {
  return request({
    url: `/api/books/${bookId}/story-practice`,
    method: 'get'
  })
}

// 获取绘本单词列表
export function getBookWords(bookId) {
  return request({
    url: `/api/books/${bookId}/words`,
    method: 'get'
  })
}

// 获取单词详情
export function getWordDetail(wordId) {
  return request({
    url: `/api/words/${wordId}`,
    method: 'get'
  })
}

// 保存评分结果
export function saveScore(data) {
  return request({
    url: '/api/score/save',
    method: 'post',
    data
  })
}

// 获取学习记录
export function getStudyRecords() {
  return request({
    url: '/api/study/records',
    method: 'get'
  })
}

// 同步本地记录到后端
export function syncRecords(records) {
  return request({
    url: '/api/study/sync',
    method: 'post',
    data: { records }
  })
}

// 保存绘本跟读单句结果
export function saveStoryLineResult(data) {
  return request({
    url: '/api/story-practice/line-result',
    method: 'post',
    data
  })
}

// 提交整次绘本跟读练习
export function completeStoryPractice(data) {
  return request({
    url: '/api/story-practice/complete',
    method: 'post',
    data
  })
}

// 获取绘本跟读历史记录
export function getStoryPracticeRecords(bookId, openid) {
  return request({
    url: '/api/story-practice/records',
    method: 'get',
    params: { bookId, openid }
  })
}

// ==================== 句子练习 API ====================

// 获取句子列表
export function getSentences() {
  return request({
    url: '/api/sentences',
    method: 'get'
  })
}

// 获取随机句子
export function getRandomSentence() {
  return request({
    url: '/api/sentences/random',
    method: 'get'
  })
}

// 句子发音评测
export function evaluateSentence(data) {
  return request({
    url: '/api/sentences/eval',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/book.js